import {useMemo} from 'react';
import {
  cookieApiRefreshTokenKey,
  cookieApiTokenKey,
} from '../../../server/token';

export type AuthTokens = {
  accessToken: string;
  refreshToken: string;
};

const hasBothTokens = (tokens: {
  accessToken?: string;
  refreshToken?: string;
}): tokens is {
  accessToken: string;
  refreshToken: string;
} => {
  return Boolean(tokens.accessToken && tokens.refreshToken);
};

type Cookies = Record<string, string>;
export const useTokensInCookies = (
  cookies: Cookies,
): AuthTokens | undefined => {
  return useMemo(() => {
    const accessToken =
      cookieApiTokenKey in cookies ? cookies[cookieApiTokenKey] : undefined;
    const refreshToken =
      cookieApiRefreshTokenKey in cookies
        ? cookies[cookieApiRefreshTokenKey]
        : undefined;
    const tokens = {accessToken, refreshToken};
    const tokenExists = hasBothTokens(tokens);
    return tokenExists ? tokens : undefined;
  }, [cookies[cookieApiTokenKey], cookies[cookieApiRefreshTokenKey]]);
};
